// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";

const productCategoriesServiceUrl = "/api/synd/category/by-ids";
const preBookCategories = "/api/synd/category/pre-book-categories";
export async function getCategoriesData(categoriesId: string[]): Promise<CategoryModel[]> {
    const result = await get<{ categories: CategoryModel[] }>(productCategoriesServiceUrl, {
        id: categoriesId,
    } as ApiParameter);
    return result.categories;
}

export async function getPreBookCategories(): Promise<CategoryModel[]> {
    const result = await get<{ categories: CategoryModel[] }>(preBookCategories);
    return result.categories;
}
